const GOOGLE_AVATAR_HOST = /(^|\.)googleusercontent\.com$/i;

export function normalizeAvatarUrl(
  url: string | null | undefined,
  size = 96,
): string | null {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (!trimmed) return null;

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return trimmed;
  }

  if (!GOOGLE_AVATAR_HOST.test(parsed.hostname)) {
    return trimmed;
  }

  if (/=s\d+/i.test(trimmed)) {
    return trimmed;
  }

  parsed.pathname = `${parsed.pathname}=s${size}-c`;
  return parsed.toString();
}
